import React, { useRef, useEffect } from "react";
import { CheckIcon, CloseIcon } from "../../../constants/Icons";

const Convertinvoice = ({ onClose, onConfirm }) => {
  const containerRef = useRef(null);

  const handleConfirm = () => {
    onConfirm("INVOICE");
    onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleConfirm();
    } else if (e.key === "Escape") {
      onClose();
    }
  };

  useEffect(() => {
    containerRef.current?.focus();
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm">
          <div
            className="modal-content"
            ref={containerRef}
            tabIndex={-1}
            onKeyDown={handleKeyDown}
          >
            <div className="modal-header">
              <h6 className="modal-title">Confirm Conversion</h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body text-center">
              <p className="mb-2">
                Do you want to convert this <strong>Bill</strong> into a{" "}
                <strong>Tax Invoice</strong>?
              </p>
              <p className="text-danger small">
                Once converted, it cannot be changed. A new Tax Invoice will be
                created.
              </p>
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary"
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleConfirm}
              >
                <CheckIcon/> Yes, Convert
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Convertinvoice;
